export const iconFontAwesomeToggleCircleDot = (
	<i className="fa-solid fa-circle-dot"></i>
);
